import VConsole from 'vconsole';
import { getUrlParam } from '@/utils';

export default () => {
  let date = new Date();
  let d = date.getDate();
  let key = process.env.VUE_APP_TEST_KEY;
  if (getUrlParam(key) == d) {
    new VConsole();
  }
};
